export default __webpack_public_path__ + "static/media/green-1.866e3e33.png";